export default (number) => {
    number = number.replace(/\D/g, '');
    return `${number.substr(0, 3)}${number.substr(3, 3) && `-${number.substr(3, 3)}`}${number.substr(6, 4) && `-${number.substr(6, 4)}`}`;
};
